import { render, staticRenderFns } from "./DialogEditTopic.vue?vue&type=template&id=2dcaa5be"
import script from "./DialogEditTopic.vue?vue&type=script&lang=js"
export * from "./DialogEditTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports